import { render, staticRenderFns } from "./ProfilBO.vue?vue&type=template&id=745c3e13"
import script from "./ProfilBO.vue?vue&type=script&lang=js"
export * from "./ProfilBO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports